const ENVIRONMENTS = [
  {
    environment: 'dev-local',
    hostname: 'localhost'
  },
  {
    environment: 'development',
    hostname: 'dppr-dev.apps.ad.corelogic.asia',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-int-ause.solutions.corelogic.com'
  },
  {
    environment: 'development',
    hostname: 'property-report-au-dev.mcom.corelogic.io',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-int-ause.solutions.corelogic.com'
  },
  {
    environment: 'uat',
    hostname: 'property-report-uat.corelogic.com.au',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-int-ause.solutions.corelogic.com'
  },
  {
    environment: 'prd',
    hostname: 'property-report.corelogic.com.au',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-ause.solutions.corelogic.com'
  },
  {
    environment: 'development',
    hostname: 'property-report-nz-dev.mcom.corelogic.io',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-int-ause.solutions.corelogic.com'
  },
  {
    environment: 'uat',
    hostname: 'property-report-uat.corelogic.co.nz',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-int-ause.solutions.corelogic.com'
  },
  {
    environment: 'prd',
    hostname: 'property-report.corelogic.co.nz',
    webSocketPort: 4443,
    apmServerUrl: 'https://apm-ause.solutions.corelogic.com'
  }
]

export { ENVIRONMENTS }
